module.exports = __webpack_public_path__ + "media/flags/bt-48d72916.svg";